import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { isTokenValid } from "../utilities/Auth"
import { postLoginReset } from "../store/actions/navActions"

const useTokenWatcher = () => {
	const dispatch = useDispatch()
	const token = useSelector((state) => state.navInfo.login.token)

	useEffect(() => {
		const interval = setInterval(() => {
			if (token && !isTokenValid(token)) {
				dispatch(postLoginReset())
			}
		}, 1000)

		return () => clearInterval(interval)
	}, [token, dispatch])
}

export default useTokenWatcher
